import * as api from '../../api'
import { jsError } from '../../common/utils'
import { buildAlertWithLocalizedMessages } from '../'

export const getPersonContracts = (personId) => {
	return (dispatch) => {
		dispatch({ type: 'GET_PERSON_CONTRACTS_LOADING' })
		api
			.contractsPersonGet(personId)
			.then((resp) => {
				dispatch(operationSucceeded(resp.data))
			})
			.catch((e) => {
				jsError(e)
				dispatch(operationFailed())
				dispatch(
					buildAlertWithLocalizedMessages(
						'ERROR',
						'GetPersonContractsErrorAlertTitle',
						'Virhe henkilön työsopimusten lukemisessa',
						e.response.data?.localizedMessages ? e.response.data.localizedMessages : null,
					),
				)
			})
	}
}

const operationSucceeded = (data) => ({
	type: 'GET_PERSON_CONTRACTS_SUCCEEDED',
	payload: { contracts: Array.isArray(data?.contracts) ? data.contracts : Array.isArray(data) ? data : [] },
})

const operationFailed = () => ({
	type: 'GET_PERSON_CONTRACTS_FAIL',
})
